import { useMemo } from 'react';
import { Fountain } from 'fountain-js';

export const useFountainParser = (fountainText) => {
  const parsed = useMemo(() => {
    if (!fountainText) return null;

    try {
      const fountain = new Fountain();
      const result = fountain.parse(fountainText, true); // true = get tokens
      return result;
    } catch (error) {
      console.error('Fountain parsing error:', error);
      return null;
    }
  }, [fountainText]);

  return parsed;
};
